// gettext shim replacing `@eventbrite/legacy-infra.i18n`.
//
// The legacy shim's `gettext` returns a lazy `GenericLazyString` object that is
// unsafe to render under React 19 (memory.md). This returns plain strings with
// optional `%(name)s` interpolation — safe to render directly.
//
// Catalog-aware: keys ARE the source strings (Transifex KEYVALUEJSON via the
// eb-ui-monoresource tag `covid-19`); setGettextMessages hydrates the locale's
// catalog in _app's getInitialProps, and missing keys render their source text
// via the key-is-fallback below. The parent-locale chain merge lives in
// app/i18n/locale.ts.
let messages: Record<string, string> = {};

export function setGettextMessages(next?: Record<string, string>): void {
    messages = next ?? {};
}

export function gettext(
    message: string,
    params?: Record<string, string | number>,
): string {
    const template = messages[message] ?? message;
    if (!params) {
        return template;
    }
    return template.replace(/%\((\w+)\)s/g, (match, key: string) =>
        key in params ? String(params[key]) : match,
    );
}
